// extracted by mini-css-extract-plugin
export var errorIcon = "_qm-1";
export var nameLogo = "_qm-0";